<template>
	<div class="view-wrapper work" v-if="document">
		<h1 class="work__page-title">{{ document.title }}</h1>

		<section class="work__showreel" v-if="document.native_video_mp4">
			<video playsinline="true" autoplay="true" muted="true" loop="true" :poster="document.native_video_fallback_image.sizes.large">
				<source
					v-if="document.native_video_webm"
					:src="document.native_video_webm.url"
					type="video/webm">
				<source
					:src="document.native_video_mp4.url"
					type="video/mp4">
			</video>
		</section>

		<section class="container">
			<c-project-list filter="all" padded="true"></c-project-list>
		</section>
	</div>
</template>

<script>
import * as utils from '@/utils/utils'
import defaultHeadData from '@/utils/defaultHeadData'
import getWorkData from '@/api/work.wp.api'
import CProjectList from '@/components/ProjectList'

export default {
	name: 'work',
	components: {
		CProjectList
	},
	data: () => ({
		documentData: null,
		headData: defaultHeadData
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta
		},
		siteSettings() {
			return this.$store.state.general.siteSettings
		},
		activeRouteUrl() {
			return utils.constructActiveRouteUrl(this.$route.fullPath)
		},
		document() {
			return this.documentData
		}
	},
	watch: {
		'$route': function() {
			this.setWorkData()
			this.updateHeadData()
		},
		defaultMeta: function() {
			this.updateHeadData()
		},
		document: function() {
			// console.log(this.document);
		}
	},
	head: {
		title: function() {
			return utils.transformHeadTitle(this.headData.title)
		},
		meta: function() {
			return utils.transformHeadMeta(this.headData.meta)
		},
		link: function() {
			return utils.transformHeadLink({ data: this.headData.link, i18n: true })
		}
	},
	beforeMount() {
		this.setWorkData()
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/work' })
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/work' })
	},
	methods: {
		setWorkData() {
			this.documentData = null
			getWorkData({ lang: this.settings.currentLang }).then(payload => {
				this.documentData = payload
				utils.setHtmlLang(this.settings.currentLang)
				this.updateHeadData()
			})
		},
		updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = utils.transformHeadData({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				})
				this.$emit('updateHead')
			}
		}
	}
}
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.work {
		padding: 3rem 0;

		&__page-title {
			@include visuallyhidden;
		}

		.container {
			min-height: 80vh;
		}

		&__showreel {
			width: 100%;
			margin-top: -5rem;
			margin-bottom: 2rem;
			margin-left: auto;
			margin-right: auto;
			// max-width: 80rem;

			@include mq($to: medium) {
				margin-top: -2rem;
			}

			video {
				width: 100%;
				height: auto;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// Work.vue?451ee77a